import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Unit } from '../../tasks/task/units/models/unit';

@Component({
  selector: 'construction-unit-dialog',
  templateUrl: './construction-unit-dialog.component.html',
  styleUrls: ['./construction-unit-dialog.component.scss']
})
export class ConstructionUnitDialogComponent implements OnInit {
  public mobile: boolean = false;
  public constructionUnit: Unit;
  public dialogTitle: string;
  public isComponent: boolean;

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ConstructionUnitDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) { }

  ngOnInit() {
    this.mobile = this.data.isMobile;
    this.constructionUnit = this.data.unit ? this.data.unit : this.data.component ? this.data.component : null;
    this.isComponent = this.data.isComponent ? this.data.isComponent : false;
  }

  close(): void {
    this.dialogRef.close(null);
  }

}
